import { render, staticRenderFns } from "./StockPick.vue?vue&type=template&id=8d9bdf0c"
import script from "./StockPick.vue?vue&type=script&lang=js"
export * from "./StockPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports